var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"09fc1b786580b4e8b990ba5a991615e5813bf108"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["impact_live_web_firebase@pitcher"]={id:"09fc1b786580b4e8b990ba5a991615e5813bf108"};
      